import * as yup from "yup";

const ValidationSchema = yup.object({
  parent: yup.string().required("Parent Organization is required"),
  orgname: yup.string().required("Organization name is required"),
  logoURL: yup.string().required("Organization Logo is required")
});

export default ValidationSchema;
